<template>
  <van-sticky>
    <div class="title-bar">
      <slot name="left-content"/>
      <div class="project-list">
        <van-dropdown-menu title-class="titleClass">
          <van-dropdown-item v-model="currentProjectId" :options="projectList" @change="changeSelectProject"/>
        </van-dropdown-menu>
        <div class="content">
          <slot name="content"/>
        </div>
      </div>
      <div class="right-content" @click="handleClick">
        <slot/>
      </div>
    </div>
  </van-sticky>
</template>

<script>
import { mapGetters } from 'vuex'
import worker from '@/api/worker'
import store from '../../_vuex/index'
export default {
  name: 'TitleBar',
  data() {
    return {
      currentProjectId: '',
      projectList: []
    }
  },
  computed: {
    ...mapGetters(['getProjectList', 'getSelectProject'])
  },
  watch: {
    getSelectProject(val) {
      this.currentProjectId = val.projectId
      this.$emit('change', val)
    }
  },
  created() {
    // this.$on('right-click', function (msg) {
    //   console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', msg)
    // })
  },
  mounted() {
    worker.projectlist().then(res => {
      if (res.data.code === 0) {
        store.commit('setProjectList', res.data.data)
        this.getProject()
      }
    })
  },
  methods: {
    /**
     * 获取当前选择工地和工地列表
     */
    getProject() {
      this.getProjectList.forEach(item => {
        this.projectList.push({ text: item.projectName, value: item.projectId })
      })
      // 设置当前选择项目id
      this.currentProjectId = this.getSelectProject ? this.getSelectProject.projectId : ''
    },
    /**
     * 改变当前选择工地
     * @param projectId
     */
    changeSelectProject(projectId) {
      const project = this.getProjectList.filter(item => item.projectId === projectId)[0]
      if (project !== null) {
        this.$store.commit('setSelectProject', project)
      }
    },
    handleClick(e) {
      this.$emit('right-click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
  .title-bar {
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: row;
    background-color: #ffffff;
    /*height: 48px;*/
    .project-list {
      flex: 1;
      display: flex;
      align-items: center;

      .content {
        text-align: right;
        flex: 1;
      }
    }

    .right-content {
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 25px;
    }
  }

  .titleClass {
    color: #fff7cc;
    font-weight: bold;
  }
</style>
<style>
  .title-bar .van-dropdown-menu__bar {
    box-shadow: none;
  }

  .title-bar .van-dropdown-menu {
    width: 200px;
  }

  .title-bar .van-dropdown-menu__item {
    justify-content: end;
  }
</style>



// WEBPACK FOOTER //
// src/components/TitleBar/index.vue